import { useEffect } from "react";
import { motion } from "framer-motion";
import { LANGS } from "@/data/content";
import { lenisRef } from "@/lib/lenis";

export default function LanguageGate({ onSelect }) {
  useEffect(() => {
    lenisRef.current?.stop();
    return () => lenisRef.current?.start();
  }, []);

  return (
    <motion.div
      data-testid="language-gate"
      className="fixed inset-0 z-[100] flex flex-col bg-[#0D0809]/95 backdrop-blur-xl"
      exit={{ y: "-100%", transition: { duration: 0.9, ease: [0.76, 0, 0.24, 1] } }}
    >
      <div className="pt-12 sm:pt-16 text-center px-6">
        <motion.h1
          initial={{ opacity: 0, y: -24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
          className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight text-[#B03A52]"
        >
          Pia Dolesch
        </motion.h1>
      </div>
      <div className="flex-1 flex flex-col items-center justify-center px-6">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.8 }}
          className="font-mono text-xs tracking-[0.25em] uppercase text-[#A89A9E] mb-10 text-center"
        >
          Choisissez votre langue · Wählen Sie Ihre Sprache · Choose your language
        </motion.p>
        <div className="w-full max-w-2xl border-t border-[#7E2438]/25">
          {LANGS.map((l, i) => (
            <motion.button
              key={l.code}
              data-testid={`lang-select-${l.code}`}
              onClick={() => onSelect(l.code)}
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.35 + i * 0.15, duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
              className="group w-full py-6 sm:py-8 border-b border-[#7E2438]/25 text-center transition-colors duration-300 hover:bg-[#7E2438]/10"
            >
              <span className="font-serif text-4xl sm:text-5xl lg:text-6xl text-[#F4EFEA] transition-all duration-300 group-hover:text-[#B03A52]">
                {l.label}
              </span>
            </motion.button>
          ))}
        </div>
      </div>
      <div className="pb-8 flex items-center justify-center gap-3">
        <span className="font-mono text-[11px] tracking-[0.25em] uppercase text-[#A89A9E]">Journalisme — Journalismus — Journalism</span>
        <span className="w-2 h-2 rounded-full bg-[#B03A52] animate-pulse" />
      </div>
    </motion.div>
  );
}
